export const isValidSurveyUrl = (value: string): boolean =>
  /^https?:\/\/[^\s/:?#]+\.[^\s/:?#]+(:\d+)?([/?#]\S*)?$/i.test(value);
